import { useJobRefetch } from '@hooks/job/refetch';
import { DefaultApiResp } from '@root/globalTypes';
import { queryFetch } from '@services/api';
import { useMutation } from '@tanstack/react-query';
import { useShowErrorToast } from '@utils/formHelpers';

export const useRemoveInternalSchedule = ({
  id,
  jobId,
  taskId,
  callback,
}: {
  id?: string;
  jobId?: string;
  taskId?: string;
  callback?: (data: DefaultApiResp) => void;
}) => {
  const { refetch, stages } = useJobRefetch({ schedule: { type: 'internal', action: 'remove' } });
  const { showErrorToast } = useShowErrorToast();

  const { mutate, isPending } = useMutation({
    mutationFn: (args?: { id: string; jobId: string }): Promise<DefaultApiResp> =>
      queryFetch({
        url: `jobs/${args?.jobId || jobId}/internal_schedules/${args?.id || id}`,
        opt: { method: 'DELETE' },
      }),
    onMutate: async () =>
      stages.update({ jobId, task: { id: taskId, schedule: undefined, status: 'to_schedule' } }),
    onError: (err, _, prev) => {
      console.error(err);
      stages.restore(jobId, prev);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      if (!data) return;
      const { errors } = data as DefaultApiResp;
      if (errors) showErrorToast(errors);
      if (callback && data) callback(data);
    },
  });

  return {
    mutate: (args?: { id: string; jobId: string }) => mutate(args),
    isLoading: isPending,
  };
};
